import { Box, Link, Text } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Row, Col, Form, InputGroup } from "react-bootstrap";
import {
  GetCountries,
  GetState,
  GetCity,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { CiMail } from "react-icons/ci";
import { FaDownLong } from "react-icons/fa6";
import InputFormControl from "../inputFormControl";
import SelectField from "../selectField";
import TextAreaField from "../textAreaField";

const BillAndShipAddressForm = ({
  handleAddress,
  addressData,
  copyShippingAdd,
  errors,
}) => {
  const [billingAddress, setBillingAddress] = useState({});

  const [shippingAddress, setShippingAddress] = useState({});

  const [billCountriesList, setBillCountriesList] = useState([]);
  const [billStateList, setBillStateList] = useState([]);
  const [billCityList, setBillCityList] = useState([]);

  const [shippCountriesList, setShippCountriesList] = useState([]);
  const [shippStateList, setShippStateList] = useState([]);
  const [shippCityList, setShippCityList] = useState([]);

  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setBillingAddress((prev) => ({ ...prev, [name]: value }));
    handleAddress(e, "billing");
  };

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress((prev) => ({ ...prev, [name]: value }));
    handleAddress(e, "shipping");
  };

  const copyBillingToShipping = () => {
    setShippingAddress({ ...billingAddress });
    setShippStateList(billStateList);
    setShippCityList(billCityList);
    copyShippingAdd(billingAddress);
  };

  useEffect(() => {
    GetCountries().then((result) => {
      setBillCountriesList(result);
      setShippCountriesList(result);
    });
  }, []);

  const handleCountryChange = (country, isBilling = true) => {
    if(isBilling){
      setBillingAddress((prev) => ({
        ...prev,
        country
      }));
      setBillStateList([]);
      setBillCityList([]);
      if (country) {
        GetState(country.id).then((result) => {
          setBillStateList(result);
        });
        handleAddress({target:{name:'country',value:country}},'billing')

      }
    }
    else{
      setShippingAddress((prev) => ({
        ...prev,
        country
      }));
      setShippStateList([]);
      setShippCityList([]);
      if (country) {
        GetState(country?.id).then((result) => {
          setShippStateList(result);
        });
        handleAddress({target:{name:'country',value:country}},'shipping')


      }
    }
  };

  const handleStateChange = (state, isBilling = true) => {
    if(isBilling){
      setBillingAddress((prev) => ({ ...prev, state }));
      if (state) {
        GetCity(billingAddress?.country?.id, state.id).then((result) => {
          setBillCityList(result);
        });
        handleAddress({target:{name:'state',value:state}},'billing')
      }
    }
    else{
      setShippingAddress((prev) => ({ ...prev, state }));
      if (state) {
        GetCity(shippingAddress?.country?.id, state.id).then((result) => {
          setShippCityList(result);
        });
        handleAddress({target:{name:'state',value:state}},'shipping')
      }
    }
  };

  useEffect(() => {
    if (addressData?.billingAddress) {
      const { country, state } = addressData?.billingAddress;

      
      const foundCountry = billCountriesList.find((c) => c.id === country?.id);
      if (foundCountry) {
        GetState(foundCountry.id).then((states) => {
          setBillStateList(states);
          const foundState = states.find((s) => s?.id === state?.id);
          if (foundState) {
            GetCity(foundCountry.id, foundState.id).then((cities) => {
              setBillCityList(cities);
            });
          }
        });
      }
      setBillingAddress(addressData?.billingAddress);
    }
  }, [addressData, billCountriesList,billStateList]);

  useEffect(() => {
    if (addressData?.shippingAddress) {
      const { country, state } = addressData.shippingAddress;
      const foundCountry = shippCountriesList.find((c) => c.id === country?.id);
      if (foundCountry) {
        GetState(foundCountry.id).then((states) => {
          setShippStateList(states);
          const foundState = states.find((s) => s.id === state.id);
          if (foundState) {
            GetCity(foundCountry.id, foundState.id).then((cities) => {
              setShippCityList(cities);
            });
          }
        });
      }
      setShippingAddress(addressData.shippingAddress);
    }
  }, [addressData, shippCountriesList,shippStateList]);

  return (
    <div className="address-form">
      <Row>
        <Col>
          <div>
            <Text>
              <strong>Billing Address</strong>
            </Text>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Attention</Form.Label>
                  <InputFormControl
                    name="attention"
                    value={billingAddress?.attention}
                    handleChange={handleBillingChange}
                    placeholder="Enter Attention"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Country / Region</Form.Label>
                  <SelectField
                    name="country"
                    handleChange={(e) => {
                      const selectedCountry = billCountriesList.find(
                        (c) => c?.id === parseInt(e.target.value)
                      );
                      handleCountryChange(selectedCountry, true);
                    }}
                    value={
                      billingAddress?.country ? billingAddress?.country?.id : ""
                    }
                    options={billCountriesList || []}
                    isId={true}
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>State</Form.Label>
                  <SelectField
                    name="state"
                    handleChange={(e) => {
                      const selectedState = billStateList?.find(
                        (item) => item?.id === parseInt(e.target.value)
                      );
                      handleStateChange(selectedState, true);
                    }}
                    value={
                      billingAddress?.state ? billingAddress?.state?.id : ""
                    }
                    options={billStateList || []}
                    isId={true}
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>City</Form.Label>
                  <SelectField
                    name="city"
                    handleChange={(e) => {
                      const selectedCity = billCityList?.find(
                        (item) => item.id === parseInt(e.target.value)
                      );
                      setBillingAddress((prev) => ({
                        ...prev,
                        city: selectedCity,
                      }));
                      handleAddress(
                        { target: { name: "city", value: selectedCity } },
                        "billing"
                      );
                    }}
                    value={billingAddress?.city ? billingAddress?.city?.id : ""}
                    options={billCityList || []}
                    isId={true}
                  />
                  
                </Box>
              </Col>
            </Row>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Address</Form.Label>
                  <TextAreaField
                   rows={2}
                   name="street1"
                   value={billingAddress?.street1}
                   handleChange={handleBillingChange}
                   placeholder="Street 1"
                   customClass="vendor-add-testarea"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label></Form.Label>
                  <TextAreaField
                   rows={2}
                   name="street2"
                   value={billingAddress?.street2}
                   handleChange={handleBillingChange}
                   placeholder="Street 2"
                   customClass="vendor-add-testarea"
                  />
                </Box>
              </Col>
            </Row>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Pin Code</Form.Label>
                  <InputFormControl
                   name="pinCode"
                   value={billingAddress?.pinCode || ""}
                   handleChange={handleBillingChange}
                   placeholder="Enter Pin Code"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Phone</Form.Label>
                  <InputFormControl
                   name="phone"
                   value={billingAddress?.phone || ""}
                   handleChange={handleBillingChange}
                   placeholder="Enter Phone"
                   groupText1={
                    <InputGroup.Text className="country-code">
                      {billingAddress?.country?.phone_code}
                    </InputGroup.Text>
                   }
                  />
                </Box>
                {errors?.billPhone && (
                  <p className="form_error">{errors?.billPhone}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Email</Form.Label>
                  <InputFormControl
                    name="email"
                    placeholder=""
                    value={billingAddress?.email}
                    handleChange={handleBillingChange}
                   groupText1={
                    <InputGroup.Text id="basic-addon1">
                      <CiMail />
                    </InputGroup.Text>
                   }
                  />
                </Box>
                {errors?.billEmail && (
                  <p className="form_error">{errors?.billEmail}</p>
                )}
              </Col>
            </Row>
          </div>
        </Col>
        <div className="vr p-0"></div>

        <Col>
          <div>
            <Box display="flex">
              <strong>Shipping Address</strong>{" "}
              <Link className="address-link" onClick={copyBillingToShipping}>
                <Box display="flex">
                  (<FaDownLong size={12} className="mt-1" /> Copy Billing
                  Address)
                </Box>
              </Link>
            </Box>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Attention</Form.Label>
                  <InputFormControl
                     name="attention"
                     value={shippingAddress?.attention}
                     handleChange={handleShippingChange}
                     placeholder="Enter Attention"
                  />
                </Box>
              </Col>
            </Row>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Country / Region</Form.Label>
                  <SelectField
                    name="country"
                    handleChange={(e) => {
                      const selectedCountry = shippCountriesList?.find(
                        (item) => item.id === parseInt(e.target.value)
                      );
                      handleCountryChange(selectedCountry, false);
                    }}
                    value={
                      shippingAddress?.country
                        ? shippingAddress?.country?.id
                        : ""
                    }
                    options={shippCountriesList || []}
                    isId={true}
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>State</Form.Label>
                  <SelectField
                    name="state"
                    handleChange={(e) => {
                      const selectedState = shippStateList?.find(
                        (item) => item?.id === parseInt(e.target.value)
                      );
                      handleStateChange(selectedState, false);
                    }}
                    value={
                      shippingAddress?.state ? shippingAddress?.state?.id : ""
                    }
                    options={shippStateList || []}
                    isId={true}
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>City</Form.Label>
                  <SelectField
                    name="city"
                    handleChange={(e) => {
                      const selectedCity = shippCityList?.find(
                        (item) => item?.id === parseInt(e.target.value)
                      );
                      setBillingAddress((prev) => ({
                        ...prev,
                        city: selectedCity,
                      }));
                      handleAddress(
                        { target: { name: "city", value: selectedCity } },
                        "shipping"
                      );
                    }}
                    value={
                      shippingAddress?.city ? shippingAddress?.city?.id : ""
                    }
                    options={shippCityList || []}
                    isId={true}
                  />
                </Box>
              </Col>
            </Row>

            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Address</Form.Label>
                  <TextAreaField
                   rows={2}
                   name="street1"
                   value={shippingAddress?.street1}
                   handleChange={handleShippingChange}
                   placeholder="Street 1"
                   customClass="vendor-add-testarea"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label></Form.Label>
                  <TextAreaField
                   rows={2}
                   name="street2"
                   value={shippingAddress?.street2}
                   handleChange={handleShippingChange}
                   placeholder="Street 2"
                   customClass="vendor-add-testarea"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Pin Code</Form.Label>
                  <InputFormControl
                   name="pinCode"
                   value={shippingAddress?.pinCode || ""}
                   handleChange={handleShippingChange}
                   placeholder="Enter Pin Code"
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Phone</Form.Label>
                  <InputFormControl
                   name="phone"
                   value={shippingAddress?.phone || ""}
                   handleChange={handleShippingChange}
                   placeholder="Enter Phone"
                   groupText1={
                    <InputGroup.Text className="country-code">
                      {shippingAddress?.country?.phone_code}
                    </InputGroup.Text>
                   }
                  />
                </Box>
                {errors?.shippPhone && (
                  <p className="form_error">{errors?.shippPhone || ""}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>Email</Form.Label>
                  <InputFormControl
                    name="email"
                    placeholder=""
                    value={shippingAddress?.email}
                    handleChange={handleShippingChange}
                    groupText1={
                    <InputGroup.Text id="basic-addon1">
                      <CiMail />
                    </InputGroup.Text>
                   }
                  />
                </Box>
                {errors?.shippEmail && (
                  <p className="form_error">{errors?.shippEmail}</p>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BillAndShipAddressForm;
